import type { AdTag, FFWDAdEventType, VideoAdTag } from "../ads.types";

export function isFFwdAdTag(tag: VideoAdTag): tag is AdTag<FFWDAdEventType> {
  return "fastforwardalternativevideoadstartevent" in tag.tracking;
}
